const InvoiceReviewBlockStore = {
    featureImage: 'marketing_site/lp/proposal/invoice.png',
    quoteAvatar:
        'marketing_site/proposals_page/AAEAAQAAAAAAAAyhAAAAJDQyYzcxOTQyLWRjZTctNDY0NC04MmY5LTM4YmQ0YThkZDNmMQ.jpg'
};

export default InvoiceReviewBlockStore;
